module.exports = __webpack_public_path__ + "static/media/atom-original.7ce634bb.svg";